import { ColorTokens, FontFamilyTokens, FontSizeTokens } from '@voltmoney/schema';
import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import Typography from '../../typography/Typography';
const CoBorrowerDigioList = ({ title, imageUrl }) => {
    return (React.createElement(View, { style: styles.container },
        React.createElement(Image, { source: { uri: imageUrl }, style: styles.itemImage, resizeMode: 'contain' }),
        React.createElement(Typography, { label: title, fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter })));
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 14,
    },
    itemImage: {
        height: 20,
        width: 20,
        marginRight: 9,
    },
});
export default CoBorrowerDigioList;
